
















import {
  Component,
  Vue
} from "vue-property-decorator";

@Component
export default class Gallery extends Vue {
  public images: string[] = [
    this.randomImage(),
    this.randomImage(),
    this.randomImage(),
    this.randomImage(),
    this.randomImage(),
    this.randomImage(),
  ]

  public loadMoreImages() {
    const newImages: string[] = [
      this.randomImage(),
      this.randomImage(),
      this.randomImage(),
      this.randomImage(),
      this.randomImage(),
      this.randomImage(),
    ]
    this.images.push(...newImages)
  }

  public randomImage(): string {
    const base = 'https://source.unsplash.com/random/'
    const width = '400x'
    const height = Math.floor(Math.random() * 301) + 300
    return base + width + height
  }
}
